import { render, staticRenderFns } from "./ExportToExcel.vue?vue&type=template&id=3a62b90d"
import script from "./ExportToExcel.vue?vue&type=script&lang=js"
export * from "./ExportToExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
